function readEnv(key: keyof Window): string {
  if (process.env.NODE_ENV !== 'production') {
    return String(process.env[key as string] ?? '').trim();
  }
  return String(window[key] ?? '').trim();
}

/** Git Integration Service API 根 URL */
export function resolveGitApiBaseUrl(): string {
  return readEnv('REACT_APP_GIT_API_BASE_URL');
}

/** pydc Data API 根 URL（含 admin/schema 物化接口） */
export function resolvePydcApiBaseUrl(): string {
  return readEnv('REACT_APP_PYDC_API_BASE_URL');
}

/** Schema 仓库默认 URL（可被界面配置覆盖，见 schemaGitSettings） */
export function resolveSchemaRepoUrl(): string {
  return readEnv('REACT_APP_SCHEMA_REPO_URL');
}

/** Schema 仓库默认分支（可被界面配置覆盖） */
export function resolveSchemaRepoBranch(): string {
  return readEnv('REACT_APP_SCHEMA_REPO_BRANCH') || 'master';
}

/** emagent REST API 根 URL（管理端用量等） */
export function resolveEmagentApiBaseUrl(): string {
  return readEnv('REACT_APP_EMAGENT_API_BASE_URL');
}

/** credit-service 根 URL（调账 / 策略；直连，不经 emagent） */
export function resolveCreditServiceBaseUrl(): string {
  return readEnv('REACT_APP_CREDIT_SERVICE_BASE_URL');
}
